import script from "./PolishAreaContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolishAreaContent.vue?vue&type=script&setup=true&lang=ts"

import "./PolishAreaContent.vue?vue&type=style&index=0&id=790e534a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790e534a"]])

export default __exports__